"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErase = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _Icons = require("./Icons");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: _propTypes.func.isRequired
} : {};

const style = () => (0, _stylitas.css)`
  display: flex;
  align-itens: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
`;

const Button = _stylitas.styled.button`
  ${style}
`;

const ButtonErase = ({
  onClick
}) => {
  return (0, _core.jsx)(Button, {
    "data-testid": "button-erase",
    onClick: onClick
  }, (0, _core.jsx)(_Icons.Erase, null));
};

exports.ButtonErase = ButtonErase;
process.env.NODE_ENV !== "production" ? ButtonErase.propTypes = propTypes : void 0;
ButtonErase.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonErase",
  "props": {
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};